import { PlayerCardProps } from './types';
import DirectusImage from '../image/DirectusImage';
import PlaceHolderMalePicture from '../../../../public/png/placeholder_male.png';
import PlaceHolderMaleNonSelectedPicture from '../../../../public/png/placeholder_male_non_selected.png';
import PlaceHolderFemalePicture from '../../../../public/png/placeholder_female.png';
import PlaceHolderFemaleNonSelectedPicture from '../../../../public/png/placeholder_female_non_selected.png';

const positionToText = (position: string) => {
  switch (position) {
    case 'entraineur':
      return 'Entraîneur';
    case 'preparateur_physique':
      return 'Préparateur physique';
    default:
      return position;
  }
}

export function PlayerCard({
  image,
  imageAlt,
  position,
  fullName,
  clubName,
  imageBlur,
  imageSizes,
  height = '',
  birthDate = '',
  man = true,
  number = 0,
  selected = false,
}: PlayerCardProps) {
  const sizes = imageSizes || '100vw';
  let imagePlaceHolder = man ? PlaceHolderMalePicture : PlaceHolderFemalePicture;
  if (!selected) {
    imagePlaceHolder = man
      ? PlaceHolderMaleNonSelectedPicture
      : PlaceHolderFemaleNonSelectedPicture;
  }

  const hover = !selected && !image ? '' : 'hover:bg-indigo-950 hover:bg-card-player-ellipse';
  const objectPositionPlaceholder = man ? '35px 65px' : '0px 65px';

  return (
    <div
      className={`card relative flex h-full min-h-[470px] w-full max-w-[386px] flex-col justify-end rounded-md bg-gray-100 ${hover} group ${!selected && 'grayscale'}`}
    >
      <div className="relative h-full w-full">
        <DirectusImage
          src={image ? image : imagePlaceHolder}
          objectFit="cover"
          objectPosition={image ? '' : objectPositionPlaceholder}
          alt={imageAlt || ''}
          blur={imageBlur}
          dimension={{ sizes }}
          styles="absolute rounded-md z-10 bottom-[0px]"
        />
      </div>
      {number >= 0 && (
        <div className="absolute top-[0px] flex">
          <span className="p-6 font-AgencyFBBlackComp text-[230px] font-normal uppercase leading-[207px] tracking-widest text-white">
            {number > 0 ? number : '0' }
          </span>
        </div>
      )}
      {(height !== '' || birthDate !== '') && (
        <div className="absolute right-0 top-0 z-10 mx-[20px] my-[14px] rounded p-2 text-sm font-medium text-white opacity-0 lg:group-hover:opacity-100">
          {height !== '' && height} {birthDate !== '' && `| ${birthDate}`}
        </div>
      )}
      <div className="absolute bottom-[0px] z-10 flex h-[50%] w-full flex-col items-start justify-end gap-2 rounded-b-md bg-gradient-to-t from-astro-gradient-start to-astro-gradient-end p-10 lg:gap-0">
        <span className="text-xs uppercase leading-6 tracking-tight text-white opacity-60 lg:leading-9">
          {positionToText(position || '')}
        </span>
        <span className="font-AgencyFBBlackComp text-3xl uppercase leading-[30px] tracking-wide text-white antialiased lg:text-4xl lg:leading-9">
          {fullName}
        </span>
        <span className="text-sm font-medium leading-6 text-white lg:leading-9">{clubName}</span>
        {(height !== '' || birthDate !== '') && (
          <div className="z-10 rounded text-sm font-medium leading-6 text-white lg:hidden">
            {height !== '' && height} {birthDate !== '' && `| ${birthDate}`}
          </div>
        )}
      </div>

      {!selected && <div className="absolute z-30 h-full w-full bg-white opacity-20"></div>}
    </div>
  );
}
